import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="container footer-grid">
        <div>
          <h4 className="footer-brand">Global Mind Wellness Centre</h4>
          <p className="footer-tagline">Compassionate Care, Anytime, Anywhere.</p>
          <p className="footer-address">Eldoret, Kenya</p>
        </div>

        <div>
          <h4>Contact</h4>
          <p>Phone: +254 711 381 420</p>
          <p>WhatsApp: +254 711 381 420</p>
          <p>Email: fasurlimited1@gmail.com</p>
        </div>

        <div>
          <h4>Quick Links</h4>
          <p><a href="/#services">Services</a></p>
          <p><a href="/#how-it-works">How It Works</a></p>
          <p><Link to="/book">Book an Appointment</Link></p>
          <p><Link to="/refer">Refer a Client</Link></p>
        </div>

        <div>
          <h4>In Crisis?</h4>
          <p className="footer-emergency">
            If you or someone else is in immediate danger, contact your local emergency
            services right away. This platform is not monitored 24/7 for emergencies.
          </p>
        </div>
      </div>

      <div className="container footer-bottom">
        <p>&copy; {new Date().getFullYear()} Global Mind Wellness Centre. All rights reserved.</p>
        <div className="footer-legal">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
}
